<template>
    <entity-list
            :entities="aois"
            :operations="operations"
            :isDisabled="isDisabled"
            :groupBy="groupBy"
            @addButtonClick="onAddAoiButtonClick"
            @removeButtonClick="onRemoveAoiButtonClick"
            @copyButtonClick="onCopyButtonClick"
            :selectedEntity.sync="selectedEntity"
    >
        <aoi-list-item slot-scope="{item}"
                       :aoi="item"
                       @downloadResultButtonClick="onDownloadResultButtonClick"
        />
    </entity-list>
</template>

<script>
    import Vue from 'vue'

    import EntityList from '@/components/entity-list/entity-list.vue'
    import AoiListItem from './aoi-list-item'

    import moment from 'moment'

    moment.locale('ru');

    export default {
        props: {
            aois: {
                type: Array,
                default: () => []
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            selectedAoi: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                selectedEntity: this.selectedAoi,
                groupBy: (item) => {
                    let today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return +today < item.creationTime ? 'Сегодня' :
                        moment(item.creationTime).format(moment(today).year() === moment(item.creationTime).year() ? "D MMMM" : "D MMMM YYYY");
                },
                operations: [
                    'create', 'copy',
                    {
                        type: 'delete',
                        condition: item => item.status !== 'inProcessing' && item.status !== 'sent'
                    }
                ]
            }
        },
        computed: {},
        methods: {
            onAddAoiButtonClick() {
                this.$emit('addButtonClick');
            },
            onCopyButtonClick(aoiId) {
                this.$emit('copyButtonClick', aoiId);
            },
            onRemoveAoiButtonClick(aoiId) {
                this.$emit('removeButtonClick', aoiId);
            },
            updateSelectedAoi(val) {
                if (val !== this.selectedAoi)
                    this.$emit('update:selectedAoi', val);
            },
            onDownloadResultButtonClick(aoiId){
                this.$emit('downloadResultButtonClick', aoiId);
            },
        },

        components: {
            EntityList,
            AoiListItem
        },

        watch: {
            selectedEntity(newVal) {
                this.updateSelectedAoi(newVal);
            },
            selectedAoi(newVal) {
                this.selectedEntity = newVal;
            }
        }
    }
</script>

<style scoped>

</style>
